import { getContext, setContext } from "svelte";
const modalKey = Symbol();
export function setModalContext(ctx) {
    setContext(modalKey, ctx);
}
export function getModalContext() {
    return getContext(modalKey);
}
